import React from 'react'; // eslint-disable-line no-unused-vars
import { connect } from 'react-redux';
import CategoryView from '../components/CategoryView'
import { getDraftItem } from '../../reducer';

import { addDraftItemCategoryId, addDraftItemCategoryName } from '../actions'

const mapStateToProps = (state) => {
  return {
    draft_item: getDraftItem(state)
  }
};

const mapDipatchToProps = (dispatch, ownProps) => {
  return {
    handleClick: () => {
      dispatch(addDraftItemCategoryId(ownProps.id));
      dispatch(addDraftItemCategoryName(ownProps.name));
    }
  }
}

export const Category = connect(mapStateToProps,mapDipatchToProps)(CategoryView);

export default Category;



// WEBPACK FOOTER //
// ./src/snapit_app/containers/Category.js